import { Divider } from '@infotech-soe/erp-ui-kit';
import { tg } from '@infotech-soe/metaschema';
import React, { memo } from 'react';

import { MenuItemViewModelType } from '../../../services/menu/MenuItemViewModel';

import GroupMenuItem from './GroupMenuItem';
import { useMenuContext } from './MenuContext';
import MenuItem from './MenuItem';
import { useSeparatorStyles } from './styles';
import { MenuItemsProps } from './types';
import WithTooltip from './WithTooltip';

const Separator = (props: { menuNestinglevel: number }): React.JSX.Element => {
  const classes = useSeparatorStyles(props.menuNestinglevel);
  return <Divider className={classes.separator} />;
};

const MenuItems = ({
  className,
  items,
  show,
}: MenuItemsProps): React.JSX.Element | null => {
  const { collapsed, getItem } = useMenuContext();

  return (
    <div className={className}>
      {show
        ? items.map(id => {
            const item = getItem(id);

            return (
              <WithTooltip
                key={id}
                condition={
                  collapsed && item.type !== MenuItemViewModelType.SEPARATOR
                }
                delay={100}
                label={tg.hasProperty(item, 'label') && item.label}
                placement="right"
              >
                {item.type === MenuItemViewModelType.ACTION ||
                item.type === MenuItemViewModelType.DISPLAY_MODE ? (
                  <MenuItem {...item} />
                ) : item.type === MenuItemViewModelType.GROUP ? (
                  <GroupMenuItem {...item}>{item.children}</GroupMenuItem>
                ) : item.type === MenuItemViewModelType.SEPARATOR ? (
                  <Separator menuNestinglevel={item.menuNestinglevel ?? 0} />
                ) : null}
              </WithTooltip>
            );
          })
        : null}
    </div>
  );
};

export default memo(MenuItems);
